<app-fr-card #commentFormRef class="comment-container">
  <!-- <mat-card-header class="cm-header" *ngIf="header && isMobile">
    <div mat-card-avatar>
      <mat-icon color="primary" class="cm-header-icon icon-comment"></mat-icon>
    </div>
    <mat-card-title class="cm-header-label">{{comments?.total}} Comments</mat-card-title>
  </mat-card-header>
  <div *ngIf="header && isMobile" class="cm-line"></div> -->
  <mat-card-content>
    <div *ngIf="variablesService.social || isLoggedIn" inViewport (inViewportAction)="postCommentInView($event)" class="cm-post-container">
      <div class="reaction-input" (click)="reactOnUpdate(update)">
        <mat-icon [ngClass]="reactionType" class="up-fb-icon" [ngStyle]="{'-webkit-text-fill-color':updateTypeColor}">
        </mat-icon>
        &nbsp;{{count}}
      </div>
      <!-- <div *ngIf="isLoggedIn" class="user-icon d-none d-sm-block">
        <app-donor id="userAvtar" [donor]="donor"></app-donor>
      </div> -->
      <form #commentFormRef [formGroup]="commentForm" (ngSubmit)="postComment()" class="cm-input-container"
        ngNativeValidate>
        <textarea #commentRef type="text" class="cm-input" formControlName="commentInput"
          [placeholder]="postCommentLabel ? postCommentLabel : ''" minlength="5" required></textarea>
        <button type="submit" class="cm-post" mat-button [disabled]="commentPostInprogess">{{'Stories.referAFriend.POST' | translatePipe | async}}</button>
      </form>
      <small class="error-message" *ngIf="commentInput.hasError('maxlength')">Comment exceeds the maximum limit</small>
    </div>

    <div *ngIf="showComments && showCommentList" #listContainer class="cm-list-container">
      <div class="cm-list" *ngFor="let item of comments?.data || comments">
        <div class="line" *ngIf="isMobile"></div>
        <app-donor [donor]="item" [showTime]="true"></app-donor>
        <div class="cm-list-comment" [ngClass]="{'reply-separator': item?.replies}"><i class="icon-leftquote quotes-icon"></i>{{item.text}}<i class="icon-rightquote quotes-icon"></i></div>
        <div *ngIf="item?.replies">
          <div *ngFor="let reply of item?.replies" class="comment-reply">
            <div class="row list-content">
              <div class="col-12">
                <app-donor [donor]="reply" [title]="reply?.posted_by"></app-donor>
                <div class="cm-list-comment"><i class="icon-leftquote quotes-icon"></i>{{reply.text}}<i class="icon-rightquote quotes-icon"></i></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="comments?.last_page>1" [ngClass]="{'hidden':isShowBtnHide}" #showMore
        class="cm-show-more">
        <button class="cm-show-btn" mat-stroked-button (click)="toggleClass()">{{'Stories.referAFriend.showMore' | translatePipe | async}}</button>
      </div>
    </div>
  </mat-card-content>
</app-fr-card>

<ng-template #loginPopupTemp>
  <app-module-loader moduleId="login-popup" selector="app-login-popup" [load]="true"></app-module-loader>
</ng-template>
